import { DecorationEntryDto } from './decoration-entry-dto';
import { SleeveDto } from './sleeve-dto';

export class SleeveEntryDto extends DecorationEntryDto {
    underlyingComponent!: SleeveDto;
}